export default __webpack_public_path__ + "static/media/arrow-expand.9dc94295.svg";